import { api } from './api'

export type GeoCountryItem = {
  iso2: string
  name: string
  iso3: string | null
  hasSubdivisions: boolean
}

const COUNTRIES_CACHE_KEY = 'shopora_admin_geo_countries_v1'

type ApiEnvelope<T> = {
  success: boolean
  data: T
}

function readCache<T>(key: string): T | null {
  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) return null
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}

function writeCache<T>(key: string, value: T): void {
  try {
    sessionStorage.setItem(key, JSON.stringify(value))
  } catch {
    /* ignore */
  }
}

/** Organisation `country` is stored as display name (e.g. "Germany"), not ISO2. */
export async function listCountries(): Promise<GeoCountryItem[]> {
  const cached = readCache<GeoCountryItem[]>(COUNTRIES_CACHE_KEY)
  if (cached?.length) return cached

  const { data } = await api.get<ApiEnvelope<{ items: GeoCountryItem[] }>>('/geo/countries')
  const items = data.data?.items ?? []
  if (items.length > 0) writeCache(COUNTRIES_CACHE_KEY, items)
  return items
}
